import React, { memo, useState, useCallback } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { SaveButton, SelectInput, SimpleForm, Toolbar } from 'react-admin';
import dataProvider from '../../../providers/dataProvider';
import { paymentStatusAvailableSelectOptions } from '../../../constants/paymentStatus';
import Loading from '../../../components/Loading/Loading';
import DialogTitleWithCloseIcon from '../../../components/DialogTitleWithCloseIcon/DialogTitleWithCloseIcon';

const UPDATE = 'UPDATE';

const CustomToolBar = (props) => {
  return (
    <Toolbar
      {...props}
      style={{
        background: 'none',
      }}
    >
      <SaveButton />
    </Toolbar>
  );
};

const UpdatePaymentStatusModal = ({ isOpen, selectedData, handleClose, refreshUser }) => {
  const [isLoading, changeLoading] = useState(false);

  const updateStatus = useCallback(
    async (values) => {
      changeLoading(true);
      await dataProvider(UPDATE, 'admin/users/product-status', {
        id: values.id,
        data: { status: values.paymentStatus },
      });
      await refreshUser();
    },
    [refreshUser],
  );

  return (
    <>
      <Dialog maxWidth="md" style={{ textAlign: 'center' }} open={isOpen} onClose={handleClose}>
        <Loading open={isLoading} />
        <DialogTitleWithCloseIcon onClose={handleClose}>
          Update Payment Type
        </DialogTitleWithCloseIcon>
        <DialogContent style={{ textAlign: 'left' }}>
          <SimpleForm record={selectedData} toolbar={<CustomToolBar />} onSubmit={updateStatus}>
            <SelectInput
              source="paymentStatus"
              label="Payment Status"
              choices={paymentStatusAvailableSelectOptions(selectedData.paymentType)}
            />
          </SimpleForm>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default memo(UpdatePaymentStatusModal);
